import { SummaryEntry } from 'types';
import { CopyButton, Text } from 'components';
import { FontSize, FontWeight, RETURN_REASONS } from 'commons';
import * as S from './styles';

interface Props {
  summaryEntry: SummaryEntry;
}

export function EntrySummary({ summaryEntry }: Props) {
  const {
    entry,
    expectedQuantity,
    reason,
    additionalReason,
    additionalInformation,
  } = summaryEntry;
  const { product } = entry;

  return (
    <S.Wrapper>
      <Text weight={FontWeight.bold}>{product.name}</Text>

      <S.CodeWrapper>
        <Text size={FontSize.font12} weight={FontWeight.bold}>
          {product.code}
        </Text>
        <CopyButton content={product.code} />
      </S.CodeWrapper>

      <S.TextWrapper>
        <Text size={FontSize.font12} weight={FontWeight.bold}>
          Quantidade
        </Text>
        <Text size={FontSize.font12}>{expectedQuantity}</Text>
      </S.TextWrapper>

      <S.TextWrapper>
        <Text size={FontSize.font12} weight={FontWeight.bold}>
          Razão da devolução
        </Text>
        <Text size={FontSize.font12}>{RETURN_REASONS[reason] || reason}</Text>
      </S.TextWrapper>

      <S.TextWrapper>
        <Text size={FontSize.font12} weight={FontWeight.bold}>
          Mais detalhes
        </Text>
        <Text size={FontSize.font12}>
          {additionalReason
            ? RETURN_REASONS[additionalReason] || additionalReason
            : 'N/A'}
        </Text>
      </S.TextWrapper>

      <S.TextWrapper>
        <Text size={FontSize.font12} weight={FontWeight.bold}>
          Informações adicionais
        </Text>
        <Text size={FontSize.font12}>
          {additionalInformation ? additionalInformation : 'N/A'}
        </Text>
      </S.TextWrapper>
    </S.Wrapper>
  );
}
